import gql from 'graphql-tag'

import { responsiveImageFragment } from '../fragments/images.js'
import { seoFragment } from '../fragments/seo.js'

export const getProduct = gql`
  ${responsiveImageFragment}
  ${seoFragment}
  query getProduct($locale: SiteLocale, $slug: String) {
    allProducts(locale: $locale) {
      id
      name
      slug
      productPretitle
      nextProductImage {
        id
        responsiveImage(imgixParams: { auto: compress, q: "60" }) {
          ...ResponsiveImageFragment
        }
      }
    }
    product(locale: $locale, filter: { slug: { eq: $slug } }) {
      id
      seo {
        ...SeoFragment
      }
      name
      slug
      productPretitle
      productDescription
      productMedia {
        id
        videoUrl
        image {
          id
          responsiveImage(imgixParams: { auto: compress, q: "60" }) {
            ...ResponsiveImageFragment
          }
        }
      }
      grid {
        id
        topList {
          id
          text
          image {
            id
            responsiveImage(imgixParams: { auto: compress, q: "60" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        header {
          id
          text
          leftImage {
            id
            responsiveImage(imgixParams: { auto: compress, q: "60" }) {
              ...ResponsiveImageFragment
            }
          }
          rightImage {
            id
            responsiveImage(imgixParams: { auto: compress, q: "60" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        main {
          id
          leftText
          leftImage {
            id
            responsiveImage(imgixParams: { auto: compress, q: "60" }) {
              ...ResponsiveImageFragment
            }
          }
          rightText
          rightImage {
            id
            responsiveImage(imgixParams: { auto: compress, q: "60" }) {
              ...ResponsiveImageFragment
            }
          }
          centralImage {
            id
            responsiveImage(imgixParams: { auto: compress, q: "60" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        bottom {
          id
          text
          image {
            id
            responsiveImage(imgixParams: { auto: compress, q: "60" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        cta {
          id
          label
          linkUrl
        }
      }
    }
  }
`
